import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { TEST_IDS } from '../../TestIds';
import { locale } from '../locale';
import { RedirectLink } from './RedirectLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const SupportLink = props => {
  return /*#__PURE__*/_jsx(RedirectLink, _objectSpread(_objectSpread({
    href: "http://go.atlassian.com/marketplace-support",
    "data-testid": TEST_IDS.APP_SUPPORT_LINK,
    target: "_blank"
  }, props), {}, {
    children: props.children || locale.contactSupport
  }));
};